import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    font-size: 1.2em;

    .details {
        border-bottom: .01em solid #000000;
        padding: 2em 0;
        cursor: pointer;

        .summary {
            display: block;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .accordion-marker {
                display: inline-block;
                border: solid black;
                border-width: 0 .12em .12em 0;
                padding: .12em;
                transform: rotate(-135deg);
                transition: transform .5s ease-in-out;
                margin-left: 1em;
            }

            &.active {
                font-weight: 600;
            }
        }

        .description {
            margin-top: 1em;
            padding-top: 1em;

            p {
                font-size: 1em;

                span {
                    font-size: 1em!important;
                }

                a {
                    color: grey;

                    &:hover {
                        color: #000000;
                    }
                }
            }

            ul {
                li {
                    list-style: disc!important;
                }
            }
        }

        .summary::-webkit-details-marker {
            display: none;
        }
    }

    &:before {
        content: "";
        display: block;
        height: 150px;
        margin: -150px 0 0;
    }

    @media all and (max-width: ${vars.tabletS}) {
        font-size: 1.125em;

        .details {
            padding: 2.1em 0 .7em;

            .summary {
                .accordion-marker {
                    border-width: 0 .22em .22em 0;
                    padding: .22em;
                }
            }

            .description {
                padding-right: .5em;
                padding-left: .5em;
                padding-top: .5em;
            }
        }
    }
`;